import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';

import DiagramUtils from "../utils/DiagramUtils";

export default class ModelRefProperty extends ObservablePropertyDescriptorObject {

    // enabled = new PropertyDescriptor(false, '启用', "列", "bool", "#anticon-en_public_successful", { enabled: false });
    // name = new PropertyDescriptor(``, "别名", "引用", "string", "#anticon-ui-text-field-format");
    // id = new PropertyDescriptor(``, "标识", "引用", "string", "#anticon-ui-text-field-format", { enabled: false });
    args = new PropertyDescriptor(null, "参数", "引用", undefined, undefined, { enabled: false });

    constructor(opts = {}) {
        super();

        this.args.value = opts.args;
        this.defineAllProperties();
    }

    toString() {
        return this.args && this._sys.ref && {
            svg: this.args.svg,
            text: this.args.id,
            description: `${this.args.type}${this.args.name ? " - " + this.args.name : ""}`,
        } || "<请设置引用>";
    }

    isValid() {
        return this.args && this._sys.ref;
    }

    refresh() {
        this.args = {
            ...this.args,
        };
    }

    reset() {
        this._sys._refJsonObject = null;
    }

    createInstanceAlways() {
        if (!this._sys.ref)
            return null;

        let obj = this._sys.ref.toJsonObject();
        if (obj && obj.type === "TemplateModel")
            obj = obj.model.diagrams.length && obj.model.diagrams[0];

        if (!obj)
            return null;

        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[obj.type];
        if (!modelInfo)
            return null;

        const model = new modelInfo.model(obj.model);
        model.setRandomId();
        model._sys.temp = true;
        model._sys.fromTemplate = true;
        return model;
    }

    createInstance() {
        if (!this._sys.ref)
            return null;

        let obj = this._sys._refJsonObject || (this._sys._refJsonObject = this._sys.ref.toJsonObject());
        if (obj && obj.type === "TemplateModel")
            obj = obj.model.diagrams.length && obj.model.diagrams[0];

        if (!obj)
            return null;

        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[obj.type];
        if (!modelInfo)
            return null;

        const model = new modelInfo.model(obj.model);
        model.setRandomId();
        model._sys.temp = true;
        model._sys.fromTemplate = true;
        return model;
    }

    fromModel(model) {

        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[model.getType()];

        this._sys.ref = model;
        this.args = {
            id: model.id,
            svg: modelInfo.svg,
            type: modelInfo.alias,
            name: model.name,
        }
    }

    restoreRefs(modelInfo) {
        if (!this.args || this.args.id !== modelInfo.id) {
            return;
        }

        this._sys.ref = modelInfo.instance;
        this.args = {
            ...this.args,
            id: modelInfo.newId,
        }
    }
}
